module.exports = __webpack_public_path__ + "img/4.086e17e4.png";